var map = {
	"./chickenKatsuBox-200-200.webp": 6379,
	"./chickenTeriyakiBox-200-200.webp": 6251,
	"./obentoTeriyaki-200-200.webp": 1336,
	"./obentoTeriyaki2-200-200.webp": 1954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4021;